import { FunnelPage } from '~/components/funnel-page';
import { useFunnel } from '~/hooks/use-funnel';
import { perchEnergyScreenMap } from '~/machines/perch-energy/screen-map';
import { copy } from './copy';
import { funnelMachine } from './machine';

export const Funnel = () => {
  const { funnel, micro, step, overrideCopy, Screen } = useFunnel({
    funnelMachine,
    screenMap: perchEnergyScreenMap,
    copy,
  });

  return (
    <FunnelPage funnel={funnel} micro={micro} step={step}>
      <Screen funnel={funnel} micro={micro} overrideCopy={overrideCopy} />
    </FunnelPage>
  );
};
